if (!customElements.get('td-booster-faqs')) {
  class TdBoosterFaqs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (this.tabs.length === 0) return;
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.activateTab(i));
        tab.addEventListener('keydown', (e) => this.onTabKeydown(e, i));
      });
      this.querySelectorAll('.td-bfaq__q').forEach((question) => {
        question.addEventListener('click', () => this.toggleQuestion(question));
      });
      const hasActive = this.tabs.some((tab) => tab.getAttribute('aria-selected') === 'true');
      if (!hasActive) this.activateTab(0, false);
    }

    activateTab(index, focus = true) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        if (this.panels[i]) this.panels[i].hidden = !selected;
      });
      if (focus) this.tabs[index].focus();
      this.resetAccordion(this.panels[index]);
    }

    resetAccordion(panel) {
      if (!panel) return;
      const questions = Array.from(panel.querySelectorAll('.td-bfaq__q'));
      questions.forEach((question, i) => this.setQuestion(question, i === 0));
    }

    toggleQuestion(button) {
      const panel = button.closest('[role="tabpanel"]');
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      if (panel) {
        panel.querySelectorAll('.td-bfaq__q').forEach((question) => this.setQuestion(question, false));
      }
      this.setQuestion(button, !isOpen);
    }

    setQuestion(button, open) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      const answer = document.getElementById(button.getAttribute('aria-controls'));
      if (answer) answer.hidden = !open;
    }

    onTabKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index === last ? 0 : index + 1;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index === 0 ? last : index - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = last;
      if (next !== null) {
        event.preventDefault();
        this.activateTab(next);
      }
    }
  }
  customElements.define('td-booster-faqs', TdBoosterFaqs);
}
